import controller from './login.controller';
import template from './login.html';

const loginComponent = {
  restrict: 'E',
  bindings: {
    onLoginCompleted: '&'
  },
  template,
  controller
};

export default loginComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/login/login.component.js
 **/